<template>
  <b-card
    title="Kayıp-Kaçak Durumu"
    class="border border-secondary"
  >
    <b-table
      :fields="fields"
      :items="items"
    >
      <template #cell(name)="data">
        <a :href="`#${data.value.replace(/[^a-z]+/i,'-').toLowerCase()}`">{{ data.value }}</a>
      </template>
    </b-table><br><br><br><br><br><br><br><br><br>
    <a href="/apps/users/view/21">
      <b-button
        class="mt-5"
        block
      >
        Tümünü Gör
      </b-button></a>
  </b-card>
</template>

<script>
import { BTable, BCard, BButton } from 'bootstrap-vue'

export default {
  components: {
    BTable,
    BCard,
    BButton,
  },
  data() {
    return {
      fields: [
        {
          key: 'firma',
          label: 'Firma Adi',
          formatter: value => `${value.first}`,
        },
        // A regular column
        'Giren kW',
        {
          // A regular column with custom formatter
          key: 'Cıkan kW',
          formatter: value => value.charAt(0),
        },
        {
          // A virtual column with custom formatter
          key: 'birthYear',
          label: 'Kayıp Miktarı',
          formatter: (value, key, item) => new Date().getFullYear() - item.age,
        },
      ],
      items: [

      ],
    }
  },
}
</script>
